import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=773aaa88&scoped=true"
import script from "./lesson.vue?vue&type=script&lang=js"
export * from "./lesson.vue?vue&type=script&lang=js"
import style0 from "./lesson.vue?vue&type=style&index=0&id=773aaa88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773aaa88",
  null
  
)

export default component.exports